// pages/MyOrders.jsx
import React, { useEffect, useState } from "react";
import OrderCard from "../../components/OrderCard";
import axiosInstance from "../../../../configuration/request";
import { useSnackbar } from "../../../../component/SnackbarContext";
import { useSelector } from "react-redux";
import {
  capitalizeStatus,
  formatServiceType,
} from "../../../../utils/customerHealperFunctions";
import { Player } from "@lottiefiles/react-lottie-player";
import notFound from "../../../../assets/animation/notFount.json";
import { useNavigate } from "react-router-dom";
import { dateFormatShort, formatDateDDMMYYYY } from "../../../../utils/dateFormat";
import { FaArrowRightLong  ,FaArrowLeftLong } from "react-icons/fa6";

export default function MyOrders() {
  const showSnackbar = useSnackbar();
  const { loginDetails } = useSelector((state) => state.counter);
  const userId = loginDetails.userId || null;

  const [ordersDetail, setOrdersDetail] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const limit = 3; // Orders per page
  const navigate = useNavigate();

  useEffect(() => {
    if (userId) {
      fetchOrders();
    }
  }, [page, userId]);

  const fetchOrders = () => {
    axiosInstance
      .get(
        `/customer/orders?user_id=${userId}&page=${page}&limit=${limit}`
      )
      .then((res) => {
        const resData = res?.data?.data || [];
const mappedOrders = resData.map((order) => {
  const items = order?.services?.items || [];

  return {
    id: order?.id,
    order_id: order?.order_id,
    title: order?.store?.storeName || "",
    rating: Number(order?.store_avg_rating) || 0,
    placedDate: formatDateDDMMYYYY(order?.created_at),
    status: capitalizeStatus(order?.status),
    service_type: order?.services?.service_type,
    service: formatServiceType(order?.services?.service_type),
    totalPrice: Number(order?.total_amount) || 0,
    totalQuantity: items.reduce(
      (acc, item) => acc + (item?.quantity || 0),
      0
    ),
    image: order?.store?.shopImageUrl || null,
  };
});

        setOrdersDetail(mappedOrders);
        if (res?.data?.meta) {
          setTotalPages(res?.data?.meta?.totalPages);
        } else {
          setTotalPages(Math.ceil((res?.data?.meta?.totalCount || 0) / limit) || 1);
        }
      })
      .catch((err) => {
        showSnackbar(
          err?.response?.data?.message || "Something went wrong!",
          "error"
        )
      });
  };

  const trackOrder = (id) => {
    navigate(`/order-tracking/${id}`);
  };

  const cancelOrder = () => {
    // implement cancel logic if needed
  };

  const handlePay = (orderId) => {
    axiosInstance
      .get(
        `/customer/orders/create-transaction/${orderId}`
      )
      .then((res) => {
        window.location.href = res?.data?.url;
      })
      .catch((err) => {
        showSnackbar(
          err?.response?.data?.message || "Something went wrong!",
          "error"
        )
      });
  };

  // console.log("ordersDetail", { ordersDetail });
  return (
    <div className="w-full">
      <h2 className="text-2xl font-[600] mb-3">
        My <span className="text-[#008ECC]">Order</span>
      </h2>

      <div className="flex flex-col gap-5">
        {ordersDetail.length > 0 ? (
          ordersDetail.map((order, idx) => (
            <OrderCard
              key={idx}
              order={order}
              trackOrder={trackOrder}
              cancleOrder={cancelOrder}
              handlePay={handlePay}

            />
          ))
        ) : (
          <div className="flex flex-col bg-white items-center justify-center py-10 text-gray-500">
            <Player
              autoplay
              loop
              src={notFound}
              style={{ height: "200px", width: "200px" }}
            />
            <p className="text-center text-sm md:text-base">
              No orders found
            </p>
          </div>
        )}
      </div>

      {/* Pagination Controls */}
      {totalPages > 1 && (
        <div className="flex justify-center items-center gap-2 mt-10">
          {/* Prev */}
          <button
            className="w-10 h-10 rounded-full bg-white font-extrabold text-[#02537F] border-2 border-[#02537F] hover:bg-gray-100 disabled:opacity-40 flex items-center justify-center"
            disabled={page === 1}
            onClick={() => setPage((prev) => prev - 1)}
          >
            <FaArrowLeftLong className="text-xl" />
          </button>

          {/* Page Numbers with Ellipsis */}
          {Array.from({ length: totalPages }, (_, i) => i + 1)
            .filter((n) => {
              return (
                n === 1 || // always show first
                n === totalPages || // always show last
                (n >= page - 2 && n <= page + 2) // show neighbors
              );
            })
            .map((n, idx, arr) => {
              const prev = arr[idx - 1];
              return (
                <React.Fragment key={n}>
                  {/* Ellipsis before skipped numbers */}
                  {prev && n - prev > 1 && (
                    <span className="px-2 text-gray-500">...</span>
                  )}
                  <button
                    onClick={() => setPage(n)}
                    className={`w-10 h-10 border-2 border-[#E4E7E9] rounded-full text-sm font-medium ${page === n
                        ? "bg-[#02537F] text-white"
                        : "bg-white border hover:bg-gray-100"
                      }`}
                  >
                    {n < 10 ? `0${n}` : n}
                  </button>
                </React.Fragment>
              );
            })}


          {/* Next */}
          <button
            className="w-10 h-10 rounded-full font-extrabold bg-white text-[#02537F] border-2 border-[#02537F] hover:bg-gray-100 disabled:opacity-40 flex items-center justify-center"
            disabled={page === totalPages}
            onClick={() => setPage((prev) => prev + 1)}
          >
            <FaArrowRightLong className="text-xl" />
          </button>
        </div>
      )}
    </div>
  );
}
